export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const DEFAULT_TIMEZONE = 'Etc/UTC'
export const KEYCODES = {
  TAB: 'Tab',
  ENTER: 'Enter',
  ESC: 'Escape',
  SPACE: 'Space',
  PAGEUP: 'PageUp',
  PAGEDOWN: 'PageDown',
  END: 'End',
  HOME: 'Home',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown'
}

export const DAYS_IN_WEEK = 7
export const DAYS_IN_MONTH = 30
export const DAYS_IN_THREE_MONTHS = 90
export const DAYS_IN_YEAR = 365

export const MINUTE_IN_SECONDS = 60
export const HOUR_IN_SECONDS = MINUTE_IN_SECONDS * 60
export const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24
export const WEEK_IN_SECONDS = DAY_IN_SECONDS * DAYS_IN_WEEK
export const MONTH_IN_SECONDS = DAY_IN_SECONDS * DAYS_IN_MONTH
export const THREE_MONTHS_IN_SECONDS = DAY_IN_SECONDS * DAYS_IN_THREE_MONTHS
export const YEAR_IN_SECONDS = DAY_IN_SECONDS * DAYS_IN_YEAR
